import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const field = "apx-ring px-3 py-2.5 rounded-lg bg-slate-900/80 border border-slate-800 outline-none w-full text-sm";

// Settings → Security: change password; the server bumps the token version so every other session is signed out.
export const ChangePasswordCard = () => {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    if (nw !== nw2) { toast.error("New passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });  // server re-issues this device's session cookie
      toast.success("Password changed — other devices have been signed out");
      setCur(""); setNw(""); setNw2("");
    } catch (err) { toast.error(apiError(err, "Could not change password")); }
    finally { setBusy(false); }
  };
  return (
    <section className="apx-card p-5" data-testid="change-password-card">
      <div className="font-display font-semibold flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-cyan-300" /> Security</div>
      <p className="text-xs text-slate-400 mt-1">Change your password. Any other signed-in device or browser will be signed out immediately.</p>
      <form onSubmit={submit} className="mt-3 grid sm:grid-cols-3 gap-3" data-testid="change-password-form">
        <input type="password" required maxLength={128} placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} className={field} data-testid="chpw-current" autoComplete="current-password" />
        <input type="password" required minLength={8} maxLength={128} placeholder="New password (8+ chars)" value={nw} onChange={(e) => setNw(e.target.value)} className={field} data-testid="chpw-new" autoComplete="new-password" />
        <input type="password" required minLength={8} maxLength={128} placeholder="Repeat new password" value={nw2} onChange={(e) => setNw2(e.target.value)} className={field} data-testid="chpw-new-2" autoComplete="new-password" />
        <div className="sm:col-span-3">
          <button type="submit" disabled={busy} className="btn-primary rounded-lg px-4 py-2 text-sm font-medium flex items-center gap-2 disabled:opacity-60" data-testid="chpw-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Update password
          </button>
        </div>
      </form>
    </section>
  );
};
